import { render, staticRenderFns } from "./SyncPanel.vue?vue&type=template&id=c61d254e"
import script from "./SyncPanel.vue?vue&type=script&lang=js"
export * from "./SyncPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports